import gql from 'graphql-tag';

const getCompaniesQuery = gql`
  {
    companies {
      name
      _id
      codes
      masterCode
      leaderboardAvailable
      competitionMode
      contentEnabled
      events {
        _id
      }
      promotions {
        _id
      }
      users {
        _id
        firstName
        lastName
      }
      logo
      emailSuffix
      isPublic
      isIdRequired
      allow_gym_subscription
    }
  }
`;

export default getCompaniesQuery;
